export default __webpack_public_path__ + "static/media/logo.ad34eda4.png";